//footer
// import Link from "next/link";
import React, { Component } from "react";
import styles from "./scss/footer.module.scss";
import { Collapse } from "antd";
import whitlogo from "../../styles/images/logo-white.svg"
// import { basePath } from "config";
class Footer extends Component {
  render() {
    const { Panel } = Collapse;
    const curr_year = new Date().getFullYear();
    return (
      <>
        <div className={styles.footer}>
          <div className={styles.containers}>
            <div className={styles.footerSec}>
              <div className={styles.footerMenu}>
                <div className={styles.logo}>
                  <a href="/">
                    <img alt="Worktual" src={whitlogo} />
                  </a>
                  {/* <p className={styles.footerDesc}>Nam posuere accumsan porta. Integer id orci sed ante tincidunt tincidunt sit amet sed libero.</p> */}
                </div>

                <div className={styles.moreMenu}>

                  <p className={`${styles.footerDesc} ${styles.firbotmsec}`}><a href="tel:0203 444 0000">0203 444 0000</a></p>
                  <p className={styles.footerDesc} ><a href="mailto:info@worktual.com">support@worktual.co.uk</a></p>
                  {/* <div className={styles.appstoreicon}>
                    <ul className={styles.socialmedia}>
                      <li>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.mundio.unifiedring&hl=en_IN&gl=US"
                          target="_blank"
                        >
                          <img alt="Google Play Store" src={`${basePath}andapp.svg`} />
                        </a>
                      </li>
                      <li>
                        <a href="https://apps.apple.com/in/app/unifiedring/id1316536909" target="_blank">
                          <img alt="App Store" src={`${basePath}iosapp.svg`} />
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>

              </div>

              <div className={styles.productlink}>
                <div className={styles.leftsisesec}>
                  {/* <h3>Products & Solutions</h3> */}
                  <ul>
                    <li>
                      <a href="https://worktual.co.uk/product/talk/" target="_blank">Talk</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/product/share/" target="_blank">Share</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/product/meet/" target="_blank">Meet</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/product/omnichannel/" target="_blank">Omnichannel</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/product/ai-contact-centre/" target="_blank">AI at every Level</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/product/virtualagent/" target="_blank">Virtual Agent</a>
                    </li>
                  </ul>
                </div>
                <div className={styles.borbtmser}></div>
                <div className={styles.leftsisesec}>
                  {/* <h3>Pricing & About</h3> */}
                  <ul>
                    <li>
                      <a href="https://worktual.co.uk/solution/small-business/" target="_blank">Small Business</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/solution/enterprise/" target="_blank">Enterprise</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/pricing/" target="_blank">Pricing</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/company/" target="_blank">Company</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/content/blog/" target="_blank">Blogs</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/partners/" target="_blank">Partners</a>
                    </li>
                    {/* <li>
                      <a href="/">Referral</a>
                    </li> */}
                  </ul>
                </div>
                <div className={styles.borbtmser}></div>
                <div className={styles.leftsisesec}>
                  {/* <h3>Resources & Policies</h3> */}
                  <ul>
                    <li>
                      <a href="https://worktual.co.uk/newsletter/" target="_blank">Newsletter</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/help/" target="_blank">Help</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/faq/" target="_blank">FAQs</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/terms/" target="_blank">Terms</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/privacy/" target="_blank">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="https://worktual.co.uk/cookies/" target="_blank">Cookies</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.socialMenu}>
                {/* <ul className={styles.socialmedia}>
                  <li>
                    <a
                      href="https://www.facebook.com/worktual.co.uk/"
                      target="_blank"
                    >
                      <img alt="Facebook" src={`${basePath}fb.svg`} />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/Worktual"
                      target="_blank"
                    >
                      <img alt="LinkedIn" src={`${basePath}linedin.svg`} />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/WorktualCo"
                      target="_blank"
                    >
                      <img alt="Twitter" src={`${basePath}twitter.svg`} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/worktual.co.uk/"
                      target="_blank"
                    >
                      <img alt="Instagram" src={`${basePath}insta.svg`} />
                    </a>
                  </li>
                </ul> */}
                {/*  <Dropdown className={`${styles.langSel}`}>
                 <Dropdown.Toggle id="dropdown-autoclose-true">
                    <img alt="" src={`${basePath}globewhite.svg`} /> English - EN
                  </Dropdown.Toggle> 

                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Menu Item</Dropdown.Item>
                    <Dropdown.Item href="#">Menu Item</Dropdown.Item>
                    <Dropdown.Item href="#">Menu Item</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
                <p className={styles.copyRightText}>© Worktual Ltd <span id="curr_year">{curr_year}</span></p>
              </div>
            </div>
            {/* <div className={styles.footertop}>
            <div className={styles.containers}>
              <div className={styles.loho}>
                <a href="/">
                  <img alt="" src={`${basePath}logo-white.svg`} />
                </a>
                <p>Nam posuere accumsan porta. Integer id orci sed ante tincidunt tincidunt sit amet sed libero.</p>
              </div>
              <div className={styles.footermenu}>

              </div>
            </div>
          </div>
          <div className={styles.footer_bottom}>
            <div className={styles.containers}>
              <div className={styles.footer_bottomes}>
                <div className={styles.rights}>
                  <ul>
                    <li>
                      <a href="/about">About</a>
                    </li>
                    <li>
                      {" "}
                      <a href="/sales">Sales</a>
                    </li>
                    <li>
                      {" "}
                      <a href="/download">Download</a>
                    </li>
                    <li>
                      <a href="/support">Support</a>
                    </li>
                  </ul>
                </div>
                <div className={styles.left}>
                  <p>© Worktual@<span id="curr_year">{curr_year}</span></p>

                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </>
    );
  }
}
export default Footer;
